// @ts-nocheck
import { forwardRef, useMemo } from "react";
import "./PdfConfirmacaoDespesasEnviadas.css";

const fmtBRL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});
const money = (v) => fmtBRL.format(Number(v) || 0);

const onlyDigits = (s) => String(s ?? "").replace(/\D/g, "");

const maskCNPJ = (v) => {
  const d = onlyDigits(v).slice(0, 14);
  if (d.length !== 14) return String(v ?? "") || "—";
  return d.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5",
  );
};

const formatDataEnvio = (value) => {
  const d = value instanceof Date ? value : value ? new Date(value) : new Date();
  if (Number.isNaN(d.getTime())) return "—";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} - ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const PdfConfirmacaoDespesasEnviadas = forwardRef(
  function PdfConfirmacaoDespesasEnviadas(
    {
      dadosSindicato = {},
      descricaoDespesas = [],
      resumoValores = {},
      dataEnvio = null,
    },
    ref,
  ) {
    const razaoSocial =
      dadosSindicato?.razaoSocial ??
      dadosSindicato?.nome ??
      dadosSindicato?.nomeSindicato ??
      "—";
    const cnpjRaw =
      dadosSindicato?.cnpj ?? dadosSindicato?.cnpjSindicato ?? "";
    const cnpj = cnpjRaw ? maskCNPJ(cnpjRaw) : "—";

    const linhas = useMemo(() => {
      const arr = Array.isArray(descricaoDespesas) ? descricaoDespesas : [];
      return arr.map((d, i) => ({
        key: `${i}-${d?.descricao ?? ""}`,
        titulo: String(d?.descricao ?? d?.titulo ?? `Despesa ${i + 1}`).trim(),
        valor: Number(d?.valor ?? 0),
        arquivo:
          d?.nomeArquivo ||
          d?.nomeComprovante ||
          d?.arquivo ||
          d?.fileName ||
          "—",
      }));
    }, [descricaoDespesas]);

    const totalComprovado =
      resumoValores?.totalComprovado != null
        ? Number(resumoValores.totalComprovado)
        : linhas.reduce((acc, x) => acc + (Number.isFinite(x.valor) ? x.valor : 0), 0);

    const totalQueSeraApoiado =
      resumoValores?.totalQueSeraApoiado != null
        ? Number(resumoValores.totalQueSeraApoiado)
        : totalComprovado;

    const valorSemComprovacao =
      resumoValores?.valorSemComprovacao != null
        ? Number(resumoValores.valorSemComprovacao)
        : 0;

    return (
      <div className="pdf-confirmacao-despesas" ref={ref}>
        <h1 className="pdf-confirmacao-despesas__title">
          CONFIRMAÇÃO DAS DESPESAS ENVIADAS
        </h1>

        <section className="pdf-confirmacao-despesas__section">
          <h2 className="pdf-confirmacao-despesas__section-title">
            DADOS DO SINDICATO
          </h2>
          <div className="pdf-confirmacao-despesas__sindicato-grid">
            <div>
              <div className="pdf-confirmacao-despesas__label">
                CNPJ DO SINDICATO
              </div>
              <div className="pdf-confirmacao-despesas__value">{cnpj}</div>
            </div>
            <div>
              <div className="pdf-confirmacao-despesas__label">
                NOME DO SINDICATO
              </div>
              <div className="pdf-confirmacao-despesas__value">
                {razaoSocial}
              </div>
            </div>
            <div>
              <div className="pdf-confirmacao-despesas__label">DATA DE ENVIO</div>
              <div className="pdf-confirmacao-despesas__value">
                {formatDataEnvio(dataEnvio)}
              </div>
            </div>
          </div>
        </section>

        <section className="pdf-confirmacao-despesas__section">
          <h2 className="pdf-confirmacao-despesas__section-title">
            DESCRIÇÃO DAS DESPESAS
          </h2>
          {linhas.length === 0 ? (
            <p className="pdf-confirmacao-despesas__empty">
              Sem despesas informadas.
            </p>
          ) : (
            <ul className="pdf-confirmacao-despesas__lista">
              {linhas.map((item, index) => (
                <li key={item.key} className="pdf-confirmacao-despesas__item">
                  <div className="pdf-confirmacao-despesas__item-title">
                    {index + 1}. {item.titulo}
                  </div>
                  <div className="pdf-confirmacao-despesas__item-meta">
                    Valor: {money(item.valor)}
                  </div>
                  <div className="pdf-confirmacao-despesas__item-meta">
                    Arquivo:{" "}
                    <span className="pdf-confirmacao-despesas__arquivo">
                      {item.arquivo}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </section>

        <section className="pdf-confirmacao-despesas__section pdf-confirmacao-despesas__section--valores">
          <h2 className="pdf-confirmacao-despesas__section-title">VALORES</h2>
          <div className="pdf-confirmacao-despesas__valores">
            <div>
              VALOR TOTAL DAS DESPESAS COMPROVADAS: {money(totalComprovado)}
            </div>
            <div>TOTAL QUE SERÁ APOIADO: {money(totalQueSeraApoiado)}</div>
            <div>VALOR SEM COMPROVAÇÃO: {money(valorSemComprovacao)}</div>
          </div>
        </section>
      </div>
    );
  },
);

export default PdfConfirmacaoDespesasEnviadas;
